module.exports = __webpack_public_path__ + "static/media/variation.00de414f.svg";